import React, { ReactElement } from 'react';
import RadioTile from '@ramsey-design-system/radio-tile';
import { Field, useFormikContext } from 'formik';
import { CoverageCheckupState } from '../../../store/step';
import { FormikFormMultiField } from '../../shared/FormikFormMultiField';

function LivingSituationStepForm(): ReactElement {
  const { values } = useFormikContext<CoverageCheckupState>();
  return (
    <FormikFormMultiField<CoverageCheckupState>
      name="livingSituation"
      as="fieldset"
    >
      <div>
        <Field
          as={RadioTile}
          name="livingSituation"
          label="Homeowner"
          value="homeowner"
          data-testid="homeowner"
          checked={values.livingSituation === 'homeowner'}
          className="mb-2 max-w-[300px]"
          size="sm"
        />
        <Field
          as={RadioTile}
          name="livingSituation"
          label="Renter"
          value="renter"
          data-testid="renter"
          checked={values.livingSituation === 'renter'}
          className="max-w-[300px]"
          size="sm"
        />
      </div>
    </FormikFormMultiField>
  );
}
export { LivingSituationStepForm };
